module.exports = __webpack_public_path__ + "media/original/missing-d44e457e.png";